import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M11.326 1.67a.75.75 0 0 1 1.345-.003l2.921 5.886 6.516.95a.75.75 0 0 1 .488 1.199l-.071.08-4.739 4.64 1.126 6.449a.75.75 0 0 1-1 .833l-.092-.042-5.821-3.103-5.819 3.103a.75.75 0 0 1-1.103-.69l.012-.102 1.133-6.449-4.746-4.64a.75.75 0 0 1 .312-1.255l.104-.023 6.551-.95z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }